import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { ROUTES } from "~/router";
import { LOGIN_STEPS } from "~/screens/Auth/Login/constants";
import { usePageTitle } from "~/shared";
import { useAuthStore, useUserStore } from "~/stores";
import { ConfirmedVisit } from "./components";

export const SchedulingConfirmedVisit = () => {
  usePageTitle("Visit Confirmation");
  const location = useLocation();
  const { isLoggedIn: isLoggedInStore, setLoginStep } = useAuthStore();
  const navigate = useNavigate();
  const isLoggedIn = isLoggedInStore();
  const setHashedUserId = useUserStore((state) => state.setHashedUserId);

  const { appointment, email: userEmail } = location.state ?? {};
  const userHash = appointment?.user?.hash;
  const emailVerified = appointment?.user?.emailVerified;

  const handleContinue = () => {
    if (isLoggedIn) {
      navigate(ROUTES.home);
      return;
    }

    if (userHash && !emailVerified) {
      setHashedUserId(userHash);
      navigate(ROUTES.emailSent, { state: { email: userEmail } });
      return;
    }

    setLoginStep(LOGIN_STEPS.EMAIL);
    navigate(ROUTES.fullLogin);
  };

  if (!appointment) return <Navigate to={ROUTES.getStarted} />;

  return (
    <ConfirmedVisit
      appointment={appointment}
      handleContinue={handleContinue}
      buttonText="Continue to my account"
      showAddToCalendar
    />
  );
};
